<mat-toolbar color="primary">
  <span>Errors Dashboard</span>
  <span class="spacer"></span>
  <div class="auto-refresh">
    <app-icon [class.rotating]="isLoading" [icon]="'refresh'"></app-icon>
    <span>Refreshing every 60s</span>
  </div>
</mat-toolbar>

<div class="container">
  <!-- Filters -->
  <mat-card class="filter-card">
    <mat-card-content>
      <div class="filter-grid">
        <mat-form-field appearance="outline">
          <mat-label>World</mat-label>
          <mat-select [(ngModel)]="filters.world" (selectionChange)="onFilterChange()">
            <mat-option value="">All Worlds</mat-option>
            <mat-option *ngFor="let w of data?.filters?.worlds" [value]="w">{{ w }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Version</mat-label>
          <mat-select [(ngModel)]="filters.version" (selectionChange)="onFilterChange()">
            <mat-option value="">All Versions</mat-option>
            <mat-option *ngFor="let v of data?.filters?.versions" [value]="v">{{ v }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Platform</mat-label>
          <mat-select [(ngModel)]="filters.platform" (selectionChange)="onFilterChange()">
            <mat-option value="">All Platforms</mat-option>
            <mat-option *ngFor="let p of data?.filters?.platforms" [value]="p">{{ p }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="date-range-field">
          <mat-label>Enter a date range</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [(ngModel)]="filters.from" (dateChange)="onFilterChange()" placeholder="Start date">
            <input matEndDate [(ngModel)]="filters.to" (dateChange)="onFilterChange()" placeholder="End date">
          </mat-date-range-input>
          <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Graph -->
  <mat-card class="graph-card">
    <mat-card-header>
      <mat-card-title>Errors over Time</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="graph-container">
        <canvas #errorChart></canvas>
        
        <div class="empty-graph" *ngIf="!isLoading && (!data || data.graph.length === 0)">
          <app-icon [icon]="'query_stats'"></app-icon>
          <p>No data for this timeframe</p>
        </div>
      </div>
    </mat-card-content>
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
  </mat-card>

  <!-- List -->
  <mat-card class="list-card">
    <mat-card-header>
      <mat-card-title>Error Log</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="table-container">
        <table mat-table [dataSource]="data?.list || []">
          <!-- Date Column -->
          <ng-container matColumnDef="dt">
            <th mat-header-cell *matHeaderCellDef> Date </th>
            <td mat-cell *matCellDef="let element"> {{ element.dt | date:'medium' }} </td>
          </ng-container>

          <!-- World Column -->
          <ng-container matColumnDef="world">
            <th mat-header-cell *matHeaderCellDef> World </th>
            <td mat-cell *matCellDef="let element"> {{ element.world }} </td>
          </ng-container>

          <!-- Error Code Column -->
          <ng-container matColumnDef="error_code">
            <th mat-header-cell *matHeaderCellDef> Error Code </th>
            <td mat-cell *matCellDef="let element">
              <span class="error-code-text" [ngClass]="getErrorLevel(element.error_code)">
                {{ element.error_code }}
              </span>
            </td>
          </ng-container>

          <!-- Version Column -->
          <ng-container matColumnDef="version">
            <th mat-header-cell *matHeaderCellDef> Version </th>
            <td mat-cell *matCellDef="let element"> {{ element.version }} </td>
          </ng-container>

          <!-- Platform Column -->
          <ng-container matColumnDef="platform">
            <th mat-header-cell *matHeaderCellDef> Platform </th>
            <td mat-cell *matCellDef="let element">
              <mat-chip-set>
                <mat-chip>
                  <app-icon matChipAvatar [icon]="getPlatformIcon(element.platform)"></app-icon>
                  {{ element.platform || 'Unknown' }}
                </mat-chip>
              </mat-chip-set>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        
        <div class="no-results" *ngIf="!isLoading && (!data || data.list.length === 0)">
          No errors found matching current filters.
        </div>
      </div>

      <mat-paginator
        [length]="totalErrors"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 25, 50, 100]"
        [pageIndex]="pageIndex"
        (page)="onPageChange($event)">
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
